import React from 'react';
import { VacationIcon } from '../../../../utils/vacation';

const Header = () => {
    return (
        <div className="flex items-center gap-2">
            <div className="bg-[#e9ecd7] p-3 rounded-full mt-4 mr-3">
                <VacationIcon className="" size={24} />
            </div>
            <div className="mt-4">
                <h1 className="text-black font-roboto-mono text-xl font-bold leading-[31.65px]">
                    Destinations
                </h1>
                <p className="text-[#1F2937] font-quicksand text-[15px] font-normal leading-[18.75px] mt-1 ">
                    Monitor and Manage Countries, Cities and Coverage
                </p>
            </div>
        </div>
    ); 
};

export default Header;
